/**
 * Converts a string to lower case similar to [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @example
 * toLower('FOO BAR');
 * // => 'foo bar'
 *
 * @function toLower
 * @param {string} str The string to convert.
 * @return {string} Returns the lower cased string.
 */
export default function toLower(str) {
	if (typeof str !== 'string') return '';

	return str.toLowerCase();
}
